'use strict';

const DEBUG_statusFields = false;


var modAnimationRunIdx = 0;
var modAnimationRun = function( options, globalContext ) {

    const self = this;

    this.namespaceIdx = 'animation-'+modAnimationRunIdx;
    this.namespace = 'animations.'+this.namespaceIdx;


    this.animIdx = modAnimationRunIdx;
    ++modAnimationRunIdx;


    this.playStarted = false;
    this.init( options, globalContext );

};

modAnimationRun.prototype.init = function( options, globalContext ) {
    var defaults = {
        autoplay: true,
        prepare: false,
        groups: [],
        animations: [],

        animationContainer: $()
    };

    this.$globalContext = $( globalContext );

    this.options = $.extend( {},
        defaults,
        options || {},
        this.$globalContext.data('animrun') || {} );


    this.$container = $( this.options.animationContainer, this.$globalContext );
    this.containerSize = {
        width: this.$container.width(),
        heigt: this.$container.height(),
        original: {
            width: parseInt( this.$container.data('origwidth') ),
            heigt: parseInt( this.$container.data('origheight') ),
        },
        factor: 1
    };
    this.containerSize.factor = this.containerSize.width / this.containerSize.original.width;


    this.isLoading = false;
    this.isPlaying = false;
    this.isStopping = false;


    this.scenario = {
        initial: {},
        mouseenter: {},
        mouseleave: {},
        click: {}
    };
    this.animList = {};


    this.onStop = this.options.onStop || function() {};

    // init animations
    this.initAnimations();

    // init groups & needed events
    this.initGroups();


    this.initAnimationEvents();
    this.update();

};

modAnimationRun.prototype.initAnimations = function() {
    const self = this;

    //this.options.animations
    this.animationsCache = {};

    $.each( this.options.animations, function( animId, anim ) {
        //console.log( anim );
        if (!anim || typeof anim != 'object') {
            return;
        }

        self.animationsCache[ animId ] = new modAnimationRunElement( self, animId, anim, {

        } );
    } );
};

modAnimationRun.prototype.initAnimationEvents = function() {
    const self = this;

    // The onmouseover event is similar to the onmouseenter event. The difference is that the onmouseenter event
    // does not bubble (does not propagate up the document hierarchy). See "More Examples" at the bottom of this
    // page to better understand the differences.

    this.mouseEntered = false;
    this.enterTimeout = null;
    this.leaveTimeout = null;
    this.enterTimeoutOffset = 5;
    this.leaveTimeoutOffset = 10;

    const mouseEnterCall = function() {
            if (!self.mouseEntered) {
                self.mouseEntered = true;
                self.onMouseEnter();
            }
        },
        mouseLeaveCall = function() {
            if (self.mouseEntered) {
                self.mouseEntered = false;
                self.onMouseLeave();
            }
        },
        mouseEnterEvt = function() {
            if (self.leaveTimeout) {
                clearTimeout( self.leaveTimeout );
                self.leaveTimeout = null;
            }

            if (!self.enterTimeout) {
                self.enterTimeout = window.setTimeout( mouseEnterCall, self.enterTimeoutOffset );
            }
        },
        mouseLeaveEvt = function() {
            if (self.enterTimeout) {
                clearTimeout( self.enterTimeout );
                self.enterTimeout = null;
            }

            if (!self.leaveTimeout) {
                self.leaveTimeout = window.setTimeout( mouseLeaveCall, self.leaveTimeoutOffset );
            }
        };

    // onmouseover onmouseout
    // onmouseenter onmouseleave
    this.$container.on('mouseenter.'+this.namespace, '.animation-element.ty-initial,.like-animation-element', mouseEnterEvt);
    this.$container.on('mouseleave.'+this.namespace, '.animation-element.ty-initial,.like-animation-element', mouseLeaveEvt);


    this.$container.on('click.'+this.namespace, '.animation-element.ty-initial,.like-animation-element', function( event, forceUpdate ) {
        self.onClick();
    });

};

modAnimationRun.prototype.initGroups = function() {
    const self = this;

    this.groupCache = {};

    $.each( this.options.groups, function( groupIdx, groupData ) {
        self.groupCache[ groupIdx ] = new modAnimationRunGroup( self, groupIdx, groupData, {

        } );

        self.scenario[ groupData.groupType ][ groupIdx ] = self.groupCache[ groupIdx ];
    } );
};


modAnimationRun.prototype.onMouseEnter = function() {
    if (this.animList['mouseleave']) {
        this.animList['mouseleave'].finish();
    }

    if (this.animList['mouseenter']) {
        this.$container.addClass('anim-mouseenter');
        this.animList['mouseenter'].play();
    }
};

modAnimationRun.prototype.onMouseLeave = function() {
    if (this.animList['mouseenter']) {
        this.animList['mouseenter'].finish();
    }

    if (this.animList['mouseleave']) {
        this.$container.addClass('anim-mouseleave');
        this.animList['mouseleave'].play();
    }
};

modAnimationRun.prototype.onClick = function() {
    if (this.animList['click']) {
        this.$container.addClass('anim-click');
        this.animList['click'].play();
    }
};


modAnimationRun.prototype.getAnimation = function( animId, callback ) {
    if (this.animationsCache[ animId ]) {
        callback( animId, this.animationsCache[ animId ] );
        return;
    }
};


modAnimationRun.prototype.stopAll = function() {
    const self = this;

    if (!this.animList) {
        return;
    }

    $.each( this.animList, function( groupType, animList ) {
        if (animList) {
            if (DEBUG_statusFields) {
                self.removeDebugEvents( groupType );
            }
            animList.stop();
        }
    } );
};

modAnimationRun.prototype.togglePause = function( pause ) {
    const self = this;

    this.paused = pause == undefined ? !this.paused : pause;

    $.each( this.animList, function( groupType, animList ) {
        if (animList) {
            animList.togglePause( self.paused );
        }
    } );
};

modAnimationRun.prototype.update = function( fromEvent ) {
    const self = this;

    if (this.isLoading) {
        return;
    }

    this.$container.find('.animation-element').remove();
    this.stopAll();
    this.animList = {};

    if (!DEBUG_statusFields) {
        $( '.stbx' ).css('display', 'none');
    }
    $( '.stbx' ).addClass('none');


    // šeit saliekam elementus?
    $.each( this.scenario, function( groupType, list ) {
        self.updateProccess( groupType, list );
    } );


    if (this.animList['initial']) {
        if (DEBUG_statusFields) {
            this.addDebugEvents( 'initial' );
        }

        this.animList[ 'initial' ].options.onStop = function() {
            self.playStarted = false;
            self.onStop();
        };
    }

    if (this.animList[ 'mouseenter' ]) {
        if (DEBUG_statusFields) {
            this.addDebugEvents( 'mouseenter' );
        }

        this.animList[ 'mouseenter' ].options.onStop = function() {
            self.$container.removeClass('anim-mouseenter');
            self.setStatus( 'mouseenter', 'waiting' );
        };
    }

    if (this.animList[ 'mouseleave' ]) {
        if (DEBUG_statusFields) {
            this.addDebugEvents( 'mouseleave' );
        }

        this.animList[ 'mouseleave' ].options.onStop = function() {
            self.$container.removeClass('anim-mouseleave');
            self.setStatus( 'mouseleave', 'waiting' );
        };
    }

    if (this.animList[ 'click' ]) {
        if (DEBUG_statusFields) {
            this.addDebugEvents( 'click' );
        }

        this.animList[ 'click' ].options.onStop = function() {
            self.$container.removeClass('anim-click');
            self.setStatus( 'click', 'waiting' );
        };
    }


    // defaulto play uzreiz;
    // defaulto play uzreiz;
    if (this.animList['initial']) {

        if (this.playStarted || this.options.autoplay) {
            this.playStarted = true;
            this.animList['initial'].play();

            if (this.options.onAnimationStart) {
                this.options.onAnimationStart(this);
            }
        } else if (this.options.prepare) {
            this.animList['initial'].prepareAnimation();
        }
    }
};

modAnimationRun.prototype.playStart = function() {
    if (!this.playStarted) {
        if (this.animList['initial']) {
            this.playStarted = true;
            this.animList['initial'].play();

            if (this.options.onAnimationStart) {
                this.options.onAnimationStart(this);
            }
        }
    }
};

modAnimationRun.prototype.playStop = function(force) {
    if (this.playStarted) {
        if (this.animList['initial']) {
            this.playStarted = false;
            this.animList['initial'].stop(force);
        }
    }
};

modAnimationRun.prototype.updateProccess = function( groupType, list ) {
    const self = this;

    this.animList[ groupType ] = new modAnimationList_v4({
        //timeFactor: .2
    });
    //this.animList[ groupType ].setTimeFactor( 10 );

    $.each( list, function( groupId, groupOb ) {
        //groupOb.reorder();
        // groupOb (modScenarioEditGroup)
        // groupOb.animationList

        // izlaižam neredzamos;
        if (!groupOb.isVisible) {
            return true;
        }

        self.addAnimWithChilds( groupType, self.animList[ groupType ], groupOb.animationListOrdered );
    } );

    this.animList[ groupType ].update();
};

modAnimationRun.prototype.addAnimWithChilds = function( groupType, targetList, animationListOrdered, targetGroup ) {
    const self = this;

    $.each( animationListOrdered, function( idx, it ) {
        const animationItem = new modAnimationItem_v4({
            /* element: it.item.$template.clone().css({
                    display: 'none'
                }).addClass('ty-'+groupType), */
            element: it.item.getElement().css({
                    display: it.item.defaultDisplay
                }).addClass('ty-'+groupType),
            size: {
                    width: it.item.getWidth(),
                    height: it.item.getHeight()
                },
            loop: it.item.loop,
            multiply: it.item.multiply,
            randomizeStart: it.item.randomizeStart,
            animdata: it.item.animData,
            autoHide: it.item.autoHide ?? true
        });
        if (it.item.cloneMode) {
            self.$container.prepend( animationItem.element );
        }

        it.item.animationItem = animationItem;
        it.item.setHasAnimation( animationItem.hasAnimation );


        // ja šim nav childs tad pievienojam parasto;
        // ja ir childs tad pievienojam
        if (it.childs) {
            const nowGroup = new modAnimationGroup_v4({

            });
            const currentGr = nowGroup.addGroup();

            nowGroup.addToGroup( currentGr, animationItem );

            // šim childs ir jāpievieno šajā grupā bet kā sub;
            const nextGr = nowGroup.addGroup();
            self.addAnimWithChilds( groupType, targetList, it.childs, {
                group: nowGroup,
                gr: nextGr
            } );

            // un šo grupu pievienojam
            if (targetGroup) {
                // ja ir target grupa tad to pievienojam grupā;
                targetGroup.group.addToGroup( targetGroup.gr, nowGroup );
            } else {
                // ja nav target grupa tad to pievienojam sarakstā;
                targetList.add( nowGroup );
            }
        } else if (targetGroup) {
            // ja ir target grupa tad to pievienojam grupā;
            targetGroup.group.addToGroup( targetGroup.gr, animationItem );
        } else {
            // ja nav target grupa tad to pievienojam sarakstā;
            targetList.add( animationItem );
        }
    } );
};


modAnimationRun.prototype.setStatus = function( type, status, text ) {
    $( '.status-'+type ).removeClass('none waiting playing stopping restarting').addClass( status )
        .find( '.txstatus' ).html( text || status );
};

modAnimationRun.prototype.addDebugEvents = function( evt ) {
    const self = this;

    self.setStatus( evt, 'waiting' );

    this.animList[ evt ].options.onStop = function() {
        self.setStatus( evt, 'waiting' );
    };
    this.animList[ evt ].options.onStart = function() {
        self.setStatus( evt, 'playing' );
    };
    this.animList[ evt ].options.onStopCancel = function() {
        self.setStatus( evt, 'playing' );
    };
    this.animList[ evt ].options.onRestart = function() {
        self.setStatus( evt, 'playing' );
    };
    this.animList[ evt ].options.onCallStop = function() {
        self.setStatus( evt, 'stopping...' );
    };
    this.animList[ evt ].options.onCallRestart = function() {
        self.setStatus( evt, 'restarting' );
    };
};
modAnimationRun.prototype.removeDebugEvents = function( evt ) {
    this.animList[ evt ].options.onStop = function() {};
    this.animList[ evt ].options.onStart = function() {};
    this.animList[ evt ].options.onStopCancel = function() {};
    this.animList[ evt ].options.onRestart = function() {};
    this.animList[ evt ].options.onCallStop = function() {};
    this.animList[ evt ].options.onCallRestart = function() {};
};



// līdzīgs: modScenarioEditAnimation
// izmanto: modAnimationItem_v4
var modAnimationRunElement = function( parent, animId, anim, options ) {
    this.init( parent, animId, anim, options );
};

modAnimationRunElement.prototype.init = function( parent, animId, anim, options ) {
    var defaults = {

    };

    this.parent = parent;
    this.animId = animId;

    this.options = $.extend( {},
        defaults,
        options || {} );


    this.groupOb = null;

    this.isVisible = true;
    this.loop = false;
    this.multiply = false;
    this.randomizeStart = false;
    this.hasAnimation = false;

    this.animationItem = null; // modAnimationItem_v4

    this.elementMode = false;
    this.cloneMode = true;
    this.fileMode = true;
    this.defaultDisplay = anim.defaultDisplay || 'none';
    this.autoHide = anim.autoHide ?? true;

    if (anim.elementMode) {
        this.elementMode = true;
        this.cloneMode = false;
    }

    this.loadAnim( anim );
};

modAnimationRunElement.prototype.loadAnim = function( anim ) {
    const size_q = 100 / this.parent.containerSize.original.width;

    this.anim = anim;
    this.animData = anim.animdata;

    this.widthDiv = this.getWidth() / 100;
    this.heightDiv = this.getHeight() / 100;

    if (this.elementMode) {
        this.$template = $( this.anim.element );
    } else {
        this.$template = $('<div></div>').addClass('animation-element').attr({
                'data-fileid': anim.file.id
            }).css({
                width: floatToInput(anim.file.width * size_q, 6) + '%',
                height: floatToInput(anim.file.height * size_q, 6) + '%'
            }).attr({
                'data-animid': this.animId
            }).append(
                $('<div></div>').addClass('inner').html( anim.file.html )
            );
    }
};

modAnimationRunElement.prototype.getElement = function() {
    if (this.cloneMode) {
        return this.$template.clone();
    }

    return this.$template;
};

modAnimationRunElement.prototype.getWidth = function() {
    return this.anim.width ?? this.anim.file.width;
};

modAnimationRunElement.prototype.getHeight = function() {
    return this.anim.height ?? this.anim.file.height;
};

modAnimationRunElement.prototype.setVisibility = function( isVisible ) {
    const visibilityChanged = this.isVisible != isVisible;

    this.isVisible = isVisible;

    if (visibilityChanged) {
        this.$template.toggleClass('visibility-none', !this.isVisible);

        if (this.animationItem) {
            if (this.animationItem.element) {
                this.animationItem.element.toggleClass('visibility-none', !this.isVisible);
            }
        }
    }
};

modAnimationRunElement.prototype.setParentVisibility = function( isVisible ) {
    this.$template.toggleClass('visibility-parent-none', !isVisible);

    if (this.animationItem) {
        if (this.animationItem.element) {
            this.animationItem.element.toggleClass('visibility-parent-none', !isVisible);
        }
    }
};

modAnimationRunElement.prototype.setLoop = function( loop ) {
    const loopChanged = this.loop != loop;

    this.loop = loop;

    if (loopChanged) {
        // scenārijs jāupdeito tapēc šeit nevajag updeitot animāciju;
        //this.animationItem.setLoop( this.loop );
    }
};

modAnimationRunElement.prototype.setMultiply = function( multiply ) {
    const multiplyChanged = this.multiply != multiply;

    this.multiply = multiply;

    if (multiplyChanged) {
        // scenārijs jāupdeito tapēc šeit nevajag updeitot animāciju;
        //this.animationItem.setMultiply( this.loop );
    }
};

modAnimationRunElement.prototype.setRandomizeStart = function( randomizeStart ) {
    const randomizeStartChanged = this.randomizeStart != randomizeStart;

    this.randomizeStart = randomizeStart;

    if (randomizeStartChanged) {
        // scenārijs jāupdeito tapēc šeit nevajag updeitot animāciju;
        //this.animationItem.setMultiply( this.loop );
    }
};

modAnimationRunElement.prototype.setHasAnimation = function( hasAnimation ) {
    this.hasAnimation = hasAnimation;
};

modAnimationRunElement.prototype.removeFromGroup = function() {
    this.groupOb = null;
};

modAnimationRunElement.prototype.addToGroup = function( groupOb ) {
    this.groupOb = groupOb;

    // uzliekam defaultos visible & not loop;
    this.setVisibility( true );
    this.setLoop( false );
    this.setHasAnimation( this.hasAnimation );
};


modAnimationRunElement.prototype.clone = function() {
    //console.log('animation.multiply clone modAnimationRunElement:');
    return new modAnimationRunElement( this.parent, this.animId, this.anim, {

    } );
};



var modAnimationRunGroup = function( parent, groupId, groupData, options ) {
    this.init( parent, groupId, groupData, options );
};

modAnimationRunGroup.prototype.init = function( parent, groupId, groupData, options ) {

    var defaults = {

    };


    this.parent = parent;

    this.options = $.extend( {},
        defaults,
        options || {} );


    this.groupId = groupId;
    this.groupType = groupData.groupType;
    this.isVisible = groupData.visibility;

    this.animationList = {};
    this.animationListOrdered = [];


    this.loadItemsDeep( groupData.items, 1 );
    this.cleanChildsDeep( this.animationListOrdered );
};

modAnimationRunGroup.prototype.loadItemsDeep = function( groupDataItems, level, itParent ) {
    const self = this;

    $.each( groupDataItems, function( itemIdx, item ) {

        self.parent.getAnimation( item.animId, function( animId, animob ) {
            let useAnimob = animob;

            // ja šī animācija jau eksistē citā grupā tad noklonējam;
            if (useAnimob.groupOb) {
                if (useAnimob.groupOb.groupId != self.groupId) {
                    useAnimob = useAnimob.clone();
                }
            }

            self.animationList[ animId ] = useAnimob;
            self.animationList[ animId ].addToGroup( self );

            useAnimob.setVisibility( item.visibility || false );
            useAnimob.setLoop( item.loop || false );
            useAnimob.setMultiply( item.multiply || false );
            useAnimob.setRandomizeStart( item.randomizeStart || false );

            let it = {
                item: useAnimob,
                childs: []
            };

            if (item.childs) {
                self.loadItemsDeep( item.childs, level + 1, it );
            }

            if (itParent) {
                itParent.childs.push( it );
            } else {
                self.animationListOrdered.push( it );
            }
        } );
    } );
};

modAnimationRunGroup.prototype.cleanChildsDeep = function( animationListOrdered ) {
    const self = this;

    $.each( animationListOrdered, function( itemIdx, item ) {
        if (item.childs.length == 0) {
            delete item.childs;
        } else {
            self.cleanChildsDeep( item.childs );
        }
    } );
};



window.modAnimationRun = modAnimationRun;